import { GetterTree } from "vuex";
import { RootState } from "../types";
import { FrState } from "./types";

export const getters: GetterTree<FrState, RootState> = {};
